import axios from "@/utils/axiosRequest"
// 获取理事会信息
export const getLsh = (news)=>{
    return axios.request({
        url:"/weilai/selectbrief",
        method:"POST",
        data:news
    })
}
// 获取理事长信息
export const getLsz = (news)=>{
    return axios.request({
        url:"/weilai/selectbrief",
        method:"POST",
        data:news
    })
}
// 获取专家顾问详情
export const getZjgw = (news)=>{
    return axios.request({
        url:"/weilai/selecttissueid",
        method:"POST",
        data:news
    })
}
// 获取关于我们的各类信息
export const getGywm = (news)=>{
    return axios.request({
        url:"/weilai/selecttissue",
        method:"POST",
        data:news
    })
}
